import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectQueueStatus = ({ control, required = true, isClearable = true, disableDiscliamStatus=true }) => {

    const titleOptions = useMemo(() => {
        return [
            { value: '1', label: 'รอคิวทำสัญญา' },
            { value: '2', label: 'แจ้งนัดและรอทำสัญญา' },
            { value: '3', label: 'สมบูรณ์' },
            { value: '4', label: 'ยกเลิก' },
            { value: '5', label: 'สละสิทธิ', isDisabled: disableDiscliamStatus  }
        ]
    }, [disableDiscliamStatus])

    return (
        <Controller
            name="queue_status"
            control={control}
            rules={{ required: required }}
            defaultValue={titleOptions[0]}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field} isClearable={isClearable} />}
        />
    )
}

export default SelectQueueStatus
